"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuReducer = exports.ElementTypes = exports.initialState = void 0;
const areas_1 = require("../config/areas");
exports.initialState = {
    isToolbarVisible: false,
    selectedFont: '',
    recentFonts: [],
    selectedElements: [],
    CONTEXT_MENU: areas_1.areaMenu.CONTEXT_MENU.filter((item) => areas_1.defaultMenu.ROOT.includes(item)),
    FLOATING_MENU: areas_1.areaMenu.FLOATING_MENU.filter((item) => areas_1.defaultMenu.ROOT.includes(item)),
    POPUP_MENU: areas_1.areaMenu.POPUP_MENU.filter((item) => areas_1.defaultMenu.ROOT.includes(item)),
    SECTION: {
        isVisible: false,
        name: null,
    },
    mode: 'NORMAL',
};
exports.ElementTypes = [
    'VIDEO_YOUTUBE',
    'VIDEO',
    'TEXT',
    'LAYOUT',
    'IMAGE',
    'STICKER',
    'ICON',
    'GROUP',
    'DEFAULT',
    'MULTISELECT',
    'BACKGROUND',
    'TABLE_EDIT',
    'TABLE',
    'HEADER_AND_FOOTER',
    'BLEED',
    'LOGO',
    'SHAPE',
];
const menuMap = {
    SHAPE: 'ICON',
    VECTOR: 'ICON',
    QRCODE: 'ICON',
};
/**
 * Reducer
 */
function convertTypes(item) {
    const upperType = item.type.toUpperCase();
    if (upperType === 'VIDEO' && item.youtube) {
        return 'VIDEO_YOUTUBE';
    }
    return menuMap[upperType] || upperType;
}
const MenuReducer = (state, action) => {
    switch (action.type) {
        case 'MODE_CHANGED': {
            const types = new Set(state.selectedElements
                .map(convertTypes)
                .filter((type) => exports.ElementTypes.includes(type)));
            const hasSelectedElements = types.size > 0;
            if (!hasSelectedElements) {
                return Object.assign(Object.assign({}, state), { mode: action.payload, CONTEXT_MENU: exports.initialState.CONTEXT_MENU, FLOATING_MENU: exports.initialState.FLOATING_MENU, POPUP_MENU: exports.initialState.POPUP_MENU, selectedElements: [] });
            }
            const options = getMenuOptions(Array.from(types), action.payload);
            return Object.assign(Object.assign({}, state), { mode: action.payload, CONTEXT_MENU: areas_1.areaMenu.CONTEXT_MENU.filter((item) => options.includes(item)), FLOATING_MENU: areas_1.areaMenu.FLOATING_MENU.filter((item) => options.includes(item)), POPUP_MENU: areas_1.areaMenu.POPUP_MENU.filter((item) => options.includes(item)) });
        }
        case 'ELEMENT_SELECTED': {
            //   //TODO: Investigate why this is not updating when selecting elements of the same type
            const types = new Set(action.payload.selectedElements
                .map(convertTypes)
                .filter((type) => exports.ElementTypes.includes(type)));
            const hasSelectedElements = types.size > 0;
            const options = getMenuOptions(Array.from(types), state.mode);
            if (!hasSelectedElements) {
                return Object.assign(Object.assign({}, state), { CONTEXT_MENU: exports.initialState.CONTEXT_MENU, FLOATING_MENU: exports.initialState.FLOATING_MENU, POPUP_MENU: exports.initialState.POPUP_MENU, selectedElements: exports.initialState.selectedElements });
            }
            return Object.assign(Object.assign({}, state), { CONTEXT_MENU: areas_1.areaMenu.CONTEXT_MENU.filter((item) => options.includes(item)), FLOATING_MENU: areas_1.areaMenu.FLOATING_MENU.filter((item) => options.includes(item)), POPUP_MENU: areas_1.areaMenu.POPUP_MENU.filter((item) => options.includes(item)), selectedElements: action.payload.selectedElements });
        }
        case 'ELEMENT_UNSELECTED':
            return Object.assign(Object.assign({}, state), { CONTEXT_MENU: exports.initialState.CONTEXT_MENU, FLOATING_MENU: exports.initialState.FLOATING_MENU, POPUP_MENU: exports.initialState.POPUP_MENU, selectedElements: exports.initialState.selectedElements });
        case 'SET_TOOLBAR':
            return Object.assign(Object.assign({}, state), { isToolbarVisible: action.payload.isToolbarVisible });
        case 'SET_SECTION':
            return Object.assign(Object.assign({}, state), { SECTION: {
                    isVisible: action.payload.isVisible,
                    name: action.payload.name,
                } });
        case 'SET_RECENT_FONTS': {
            const filteredFonts = action.payload.fonts.filter((font) => !state.recentFonts.find((f) => f === font));
            return Object.assign(Object.assign({}, state), { recentFonts: [...state.recentFonts, ...filteredFonts] });
        }
        default:
            return state;
    }
};
exports.MenuReducer = MenuReducer;
function getMenuOptions(types, mode) {
    if (mode !== 'NORMAL') {
        return areas_1.defaultMenu[mode];
    }
    if (types.length === 1) {
        return areas_1.defaultMenu[types[0]];
    }
    return types.reduce((acc, type) => {
        return acc.filter((item) => areas_1.defaultMenu[type].includes(item));
    }, areas_1.defaultMenu[types[0]]);
}
//# sourceMappingURL=menu.store.js.map